/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react';
import { Typography, Box, Divider, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper, useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import { useTheme } from '@emotion/react';
import ReplayOutlinedIcon from '@mui/icons-material/ReplayOutlined';
import { formatPrice } from '../../utils';
import TimeDropdown from '../../components/dropdowns/timeDropdown';
import ReportService from '../../services/reportService';
import PdfMoneyMovementReport from '../../components/prints/report/pdfMoneyMovemenetReport';
import BranchDropdown from '../../components/dropdowns/branchDropdown';
import { AuthContext } from '../../provider/authProvider';

const MoneyMovementReport = () => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const isEn = i18n.language === 'en';
    const tableHeadingStyle = { fontWeight: 'bold', backgroundColor: theme.palette.customGrey.tableHeading, cursor: 'pointer' };
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));

    const [reports, setReports] = useState([]);
    const [totalCome, setTotalCome] = useState(0);
    const [totalGo, setTotalGo] = useState(0);
    const [total, setTotal] = useState(0);

    const [selectedBranch, setSelectedBranch] = useState(null);
    const [selectedTime, setSelectedTime] = useState({
        time: 'today',
        value: t('today')
    });

    const { user } = useContext(AuthContext);
    const userPermissions = user?.permissions || [];
    const allBranchPermission = userPermissions?.some(p => p.value === 'allBranches');

    const [isLoading, setIsLoading] = useState(false);

    const fetchReport = async () => {
        if (isLoading) return;
        setIsLoading(true);
        try {
            const filters = {
                branchId: selectedBranch?.id,
                ...selectedTime
            };

            const data = await ReportService.fetchMoneyMovemenets(filters);
            const { reports, totalCome, totalGo, total } = data;

            setReports(reports);
            setTotalCome(totalCome);
            setTotalGo(totalGo);
            setTotal(total);

        } catch (error) {
            console.error('Error fetching report:', error);
        } finally {
            setIsLoading(false);
        }
    };


    const resetFilter = () => {
        setSelectedTime({
            time: 'today',
            value: t('today')
        });
        setSelectedBranch(null);
    };


    useEffect(() => {
        fetchReport();
    }, [selectedBranch, selectedTime]);

    return (
        <Box sx={{
            p: isTablet ? 1 : 2,
            backgroundColor: theme.palette.secondary.main,
            width: '100%',
        }}>

            {/* Totals row */}
            {
                isTablet ?
                    <Box
                        sx={{
                            mb: 1,
                            border: 1,
                            borderColor: theme.palette.customGrey.borderInput,
                            backgroundColor: 'white',
                            borderRadius: 1,
                            width: '100%'
                        }}
                    >
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            height: 50,
                        }}>
                            <Box width={'50%'}>
                                <Typography variant="body1" sx={{ mx: 1 }}>
                                    {t('totalGo')}: <span style={{ fontWeight: 'bold' }}>{formatPrice(totalGo)}</span>
                                </Typography>
                            </Box>
                            <Divider orientation="vertical" />
                            <Box width={'50%'}>
                                <Typography variant="body1" sx={{ mx: 1 }}>
                                    {t('totalCome')}: <span style={{ fontWeight: 'bold' }}>{formatPrice(totalCome)}</span>
                                </Typography>
                            </Box>
                        </Box>

                        <Divider />

                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            height: 50,
                        }}>

                            <Box width={'50%'}>
                                <Typography variant="body1" sx={{ mx: 1 }}>
                                    {t('netTotal')}: <span style={{ fontWeight: 'bold' }}>{formatPrice(total)}</span>
                                </Typography>
                            </Box>

                            <Divider orientation="vertical" />

                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: '50%'
                                }}>
                                <PdfMoneyMovementReport
                                    data={{
                                        branch: selectedBranch,
                                        time: selectedTime,
                                    }}
                                />
                            </Box>
                        </Box>
                    </Box>
                    :
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'end'
                    }}>
                        <Box
                            sx={{
                                mb: 1,
                                display: 'flex',
                                alignItems: 'center',
                                border: 1,
                                borderColor: theme.palette.customGrey.borderInput,
                                backgroundColor: 'white',
                                borderRadius: 1,
                                height: 60,
                                width: isTablet ? '100%' : '65%'
                            }}
                        >
                            <Box width={'30%'}>
                                <Typography variant="body1" sx={{ mx: 1 }}>
                                    {t('totalGo')}: <span style={{ fontWeight: 'bold' }}>{formatPrice(totalGo)}</span>
                                </Typography>
                            </Box>
                            <Divider orientation="vertical" />
                            <Box width={'30%'}>
                                <Typography variant="body1" sx={{ mx: 1 }}>
                                    {t('totalCome')}: <span style={{ fontWeight: 'bold' }}>{formatPrice(totalCome)}</span>
                                </Typography>
                            </Box>
                            <Divider orientation="vertical" />
                            <Box width={'30%'}>
                                <Typography variant="body1" sx={{ mx: 1 }}>
                                    {t('netTotal')}: <span style={{ fontWeight: 'bold' }}>{formatPrice(total)}</span>
                                </Typography>
                            </Box>


                            <Divider orientation="vertical" />

                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: '10%'
                                }}>
                                <PdfMoneyMovementReport
                                    data={{
                                        branch: selectedBranch,
                                        time: selectedTime,
                                    }}
                                />
                            </Box>
                        </Box>
                    </Box>
            }

            {/* Filter row */}
            {
                isTablet ?
                    <Box
                        sx={{
                            mb: 2,
                            border: 1,
                            borderColor: theme.palette.customGrey.borderInput,
                            backgroundColor: 'white',
                            borderRadius: 1,
                        }}
                    >
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            height: 50
                        }}>
                            <Box sx={{ px: 2 }}>
                                <FilterAltOutlinedIcon />
                            </Box>
                            {allBranchPermission && <Divider orientation="vertical" />}
                            {allBranchPermission && <Box width={'70%'}>
                                <BranchDropdown
                                    isFilter={true}
                                    selectedBranch={selectedBranch}
                                    setSelectedBranch={setSelectedBranch}
                                />
                            </Box>}

                            <Divider orientation="vertical" />
                            <Box
                                sx={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    color: theme.palette.text.red,
                                    px: 2,
                                    cursor: 'pointer',
                                }}
                                onClick={resetFilter}
                            >
                                <ReplayOutlinedIcon />
                                <Box width={3}></Box>
                                <Typography variant="subtitle2">{t('resetFilter')}</Typography>
                            </Box>
                        </Box>

                        <Divider />
                        <Box width={'100%'} height={50}>
                            <TimeDropdown
                                isFilter={true}
                                selectedTime={selectedTime}
                                setSelectedTime={setSelectedTime}
                            />
                        </Box>
                    </Box>
                    :
                    <Box
                        sx={{
                            mb: 2,
                            display: 'flex',
                            alignItems: 'center',
                            border: 1,
                            borderColor: theme.palette.customGrey.borderInput,
                            backgroundColor: 'white',
                            borderRadius: 1,
                            height: 60,
                        }}
                    >
                        <Box sx={{ px: 2 }}>
                            <FilterAltOutlinedIcon />
                        </Box>
                        <Divider orientation="vertical" />
                        <Box width={allBranchPermission ? '55%' : '70%'}>
                            <TimeDropdown
                                isFilter={true}
                                selectedTime={selectedTime}
                                setSelectedTime={setSelectedTime}
                            />
                        </Box>
                        {allBranchPermission && <Divider orientation="vertical" />}
                        {allBranchPermission && <Box width={'25%'}>
                            <BranchDropdown
                                isFilter={true}
                                selectedBranch={selectedBranch}
                                setSelectedBranch={setSelectedBranch}
                            />
                        </Box>}

                        <Divider orientation="vertical" />
                        <Box
                            sx={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                color: theme.palette.text.red,
                                px: 2,
                                cursor: 'pointer',
                            }}
                            onClick={resetFilter}
                        >
                            <ReplayOutlinedIcon />
                            <Box width={3}></Box>
                            <Typography variant="subtitle2">{t('resetFilter')}</Typography>
                        </Box>
                    </Box>
            }

            {/* Scrollable Table with Sticky Header */}
            <TableContainer
                component={Paper}
                sx={{
                    boxShadow: 'none',
                    border: 1,
                    borderColor: theme.palette.customGrey.borderInput,
                    borderRadius: 2,
                    height: 'calc(100vh - 226px)',
                    overflowY: 'auto',
                }}
            >
                <Table stickyHeader aria-label="simple table">
                    <TableHead
                        sx={{
                            position: 'sticky',
                            top: 0,
                            zIndex: 1,
                        }}
                    >
                        <TableRow>
                            <TableCell align={isEn ? 'left' : 'right'} sx={tableHeadingStyle}>{t('date')}</TableCell>
                            <TableCell align={isEn ? 'left' : 'right'} sx={tableHeadingStyle}>{t('goAmount')}</TableCell>
                            <TableCell align={isEn ? 'left' : 'right'} sx={tableHeadingStyle}>{t('comeAmount')}</TableCell>
                            <TableCell align={isEn ? 'left' : 'right'} sx={tableHeadingStyle}>{t('netAmount')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {reports.map((report, index) => (
                            <TableRow
                                key={report.date} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell align={isEn ? 'left' : 'right'}>{report.date}</TableCell>
                                <TableCell align={isEn ? 'left' : 'right'}>{formatPrice(report.goAmount)}</TableCell>
                                <TableCell align={isEn ? 'left' : 'right'}>{formatPrice(report.comeAmount)}</TableCell>
                                <TableCell align={isEn ? 'left' : 'right'}>{formatPrice(report.netAmount)}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default MoneyMovementReport;
